<template>
  <v-card-title>
    {{ service.title }}
    <v-spacer></v-spacer>
    <price v-if="isOffer" :value="service.price"></price>
  </v-card-title>
</template>

<script>
  import Service from '@/api/service'
  import { Price } from '@/components/formatters'
  export default {
    components: {
      Price
    },
    props: {
      service: {
        type: Object,
        required: true
      },
      scope: {
        type: String,
        default: 'public'
      }
    },
    computed: {
      isOffer () { return Service.isOfferScope(this.scope) }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/service/Header.vue